import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#fff9e6] relative overflow-hidden">
      
      {/* Top Quote Bar */}
      <div className="bg-[#a85050] py-6 text-center relative">
        <p className="text-white italic text-lg font-serif">
          It’s just <span className="font-semibold">SO SO GOOD!</span>
        </p>

        {/* Decorative hearts */}
        <span className="absolute left-6 top-2 text-xl">💗</span>
        <span className="absolute left-12 top-4 text-xl">💛</span>
        <span className="absolute right-6 top-4 text-xl">💜</span>
      </div>

      {/* Main Footer */}
      <div className="bg-[#a3436b] text-[#fff6e5] py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">

          {/* Social Icons */}
    


          {/* Footer Links */}
          <div className="flex flex-wrap justify-center gap-8 text-lg font-serif mb-8">
            <Link to="/">My Recipes</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/about">About</Link>
            <Link to="/shop">Shop</Link>
          </div>

          {/* Email */}
          <p className="mb-8 text-lg">
            info@meenakshikooks.com
          </p>

          {/* Divider */}
          <div className="h-px w-64 bg-[#e8cfd6] mx-auto mb-6" />

          {/* Copyright */}
          <p className="text-sm">
            © 2025 meenakshi kooks. All Right Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
